import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import FerryService from "../../services/ferry.service";

export const getFerry = createAsyncThunk(
  "ferry/getFerry",
  async (params, thunkAPI) => {
    try {
      const response = await FerryService.getFerry(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addFerry = createAsyncThunk(
  "ferry/addFerry",
  async (data, thunkAPI) => {
    try {
      const response = await FerryService.addFerry(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateFerry = createAsyncThunk(
  "ferry/updateFerry",
  async (payload, thunkAPI) => {
    try {
      const response = await FerryService.editFerry(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteFerry = createAsyncThunk(
  "ferry/deleteFerry",
  async (id, thunkAPI) => {
    try {
      await FerryService.deleteFerry(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  ferryList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const ferrySlice = createSlice({
  name: "ferry",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getFerry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFerry.fulfilled, (state, action) => {
        state.loading = false;
        state.ferryList = action.payload?.ferryData || [];
      })
      .addCase(getFerry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addFerry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addFerry.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.ferryData ||
          action.payload;

        if (newHotel) {
          state.ferryList.unshift(newHotel);
        }
      })
      .addCase(addFerry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updateFerry.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateFerry.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.ferryData;

        if (updated?._id) {
          const index = state.ferryList.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.ferryList[index] = updated;
          }
        }
      })
      .addCase(updateFerry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deleteFerry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFerry.fulfilled, (state, action) => {
        state.loading = false;
        state.ferryList = state.ferryList.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteFerry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = ferrySlice.actions;
export default ferrySlice.reducer;
